import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// OnboardingSummary interface defines the structure of the onboarding summary data.
export interface OnboardingSummary {
  role: string;
  market: string;
  focus: string;
  recommendations: string[];
}

// OnboardingState interface defines the structure of the onboarding state in the Redux store.
export interface OnboardingState {
  selectedNeeds: string[];
  regions: string[];
  markets: string[];
  description: string;
  summary?: OnboardingSummary;
  completed: boolean;
}

// Initial state of the onboarding slice.
const initialState: OnboardingState = {
  selectedNeeds: [],
  regions: [],
  markets: [],
  description: "",
  summary: undefined,
  completed: false,
};

// Creating the onboarding slice using Redux Toolkit's createSlice function.
const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    setNeedsSelection(state, action: PayloadAction<string[]>) {
      state.selectedNeeds = action.payload;
    },
    setRegions(state, action: PayloadAction<string[]>) {
      state.regions = action.payload;
    },
    setMarkets(state, action: PayloadAction<string[]>) {
      state.markets = action.payload;
    },
    setDescription(state, action: PayloadAction<string>) {
      state.description = action.payload;
    },
    setSummary(state, action: PayloadAction<OnboardingSummary | undefined>) {
      state.summary = action.payload;
    },
    completeOnboarding(state) {
      console.log("Onboarding complete:", JSON.parse(JSON.stringify(state)));
      state.completed = true;
    },
    resetOnboarding() {
      return initialState;
    },
  },
});

// Exporting the action creators and the reducer from the onboarding slice.
export const {
  setNeedsSelection,
  setRegions,
  setMarkets,
  setDescription,
  setSummary,
  completeOnboarding,
  resetOnboarding,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
